export default __webpack_public_path__ + "static/media/check-search.878f6933.svg";